var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconDashboard24Line = function SvgIconDashboard24Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7 4.65H7.3c-1.46 0-2.65 1.19-2.65 2.65v9.4c0 1.46 1.19 2.65 2.65 2.65h9.4c1.46 0 2.65-1.19 2.65-2.65V7.3c0-1.46-1.19-2.65-2.65-2.65Zm-9.4 1.7h9.4a.95.95 0 0 1 .95.95v1.85H6.35V7.3a.95.95 0 0 1 .95-.95ZM6.35 16.7v-5.85h2.8v6.8H7.3a.95.95 0 0 1-.95-.95Zm10.35.95h-5.85v-6.8h6.8v5.85a.95.95 0 0 1-.95.95Z",
    fill: "current"
  })));
};
export default SvgIconDashboard24Line;